import React, { useState, useEffect } from "react";
import {reservationsActions, useSelector} from "inbooma-api";
import { Biscuit} from "../../../../utils";
import t from '../../../helpers/t';
import {_,moment} from '../../../../../vendor';
import MicroWidget from "../../../components/MicroWidget";


const WidgetCheckins = (props) => {

    const [initialized,setInitialized] = useState(false);
    const _reservations = useSelector(state => state.reservations.getReservations);

    const [reservationCounts,setReservationCounts] = useState({
        'inprogress' : 0,
        'booking_process' : 0,
        'completed' : 0,
        'confirmed' : 0
    });

    const [reservationStatus,setReservationStatus] = useState({
        'inprogress' : 'init',
        'booking_process' : 'init',
        'completed' : 'init',
        'confirmed' : 'init'
    });

    const filter = {
        //'begin_lt' : moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        //'end_gte' : moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        //'finder' : 'NotCancelled',
        'begin_day' : moment().format('YYYY-MM-DD'),
        'find' : 'short',
        //'limit': '999',
        'limit' : '1',
        'page' : '1',
        'sort' : 'begin',
        'direction' : 'asc'
    };

    useEffect(() => {

        if (_reservations.success === "") return;
    
        if (_reservations.success === true) {
            // update status and counts
            if (typeof _reservations.data !== 'undefined' && _reservations.data.length > 0) {
                var counts_clone = {...reservationCounts};
                counts_clone[_reservations.data[0].status] = _reservations.pagination.count;
                setReservationCounts(counts_clone);
            }
            if (reservationStatus.inprogress === 'pending') {
                setReservationStatus({
                    ...reservationStatus,
                    inprogress: 'ready'
                });
            }
            if (reservationStatus.booking_process === 'pending') {
                setReservationStatus({
                    ...reservationStatus,
                    booking_process: 'ready'
                });
            }
            if (reservationStatus.completed === 'pending') {
                setReservationStatus({
                    ...reservationStatus,
                    completed: 'ready'
                });
            }
            if (reservationStatus.confirmed === 'pending') {
                setReservationStatus({
                    ...reservationStatus,
                    confirmed: 'ready'
                });
                setInitialized(true);
                if(typeof props.setInitialized !== 'undefined'){
                    props.setInitialized(true);
                }
                props.dispatch(reservationsActions.getReservationsResetData());
            }
        } else {
          console.log("Failed to request reservations!");
        }
    },[_reservations]);

    const getCheckinsToday = () => {

        return reservationCounts.inprogress + reservationCounts.booking_process + reservationCounts.completed;
    };

    const getPossibleCheckinsToday = () => {

        return reservationCounts.confirmed + getCheckinsToday();
    };

    const initialize = () => {

        if (initialized === true) return;
        let cloneFilter = {};
        Object.assign(cloneFilter,filter);
        if(typeof props.client_id !== 'undefined'){
            cloneFilter.client_id = props.client_id
        }
        if (reservationStatus.inprogress === 'init') {

            props.dispatch(reservationsActions.getReservations({
                token: Biscuit.get('token'),
                suffix: "",
                filter: {
                    ...cloneFilter,
                    status: 'inprogress'
                }
            }));

            let clone = {...reservationStatus};
            clone.inprogress = 'pending';
            setReservationStatus(clone);
            return;
        }

        if (reservationStatus.inprogress === 'ready' && reservationStatus.booking_process === 'init') {

            props.dispatch(reservationsActions.getReservations({
                token: Biscuit.get('token'),
                suffix: "",
                filter: {
                    ...cloneFilter,
                    status: 'booking_process'
                }
            }));

            let clone = {...reservationStatus};
            clone.booking_process = 'pending';
            setReservationStatus(clone);
            return;
        }

        if (reservationStatus.booking_process === 'ready' && reservationStatus.completed === 'init') {

            props.dispatch(reservationsActions.getReservations({
                token: Biscuit.get('token'),
                suffix: "",
                filter: {
                    ...cloneFilter,
                    status: 'completed'
                }
            }));

            let clone = {...reservationStatus};
            clone.completed = 'pending';
            setReservationStatus(clone);
            return;
        }

        if (reservationStatus.completed === 'ready' && reservationStatus.confirmed === 'init') {

            props.dispatch(reservationsActions.getReservations({
                token: Biscuit.get('token'),
                suffix: "",
                filter: {
                    ...cloneFilter,
                    status: 'confirmed'
                }
            }));

            let clone = {...reservationStatus};
            clone.confirmed = 'pending';
            setReservationStatus(clone);
        }
/*
        props.dispatch(reservationsActions.getReservations({
            token: Biscuit.get('token'),
            suffix: "",
            filter: {
                ...filter,
                status: 'booking_process'
            }
        }));

        props.dispatch(reservationsActions.getReservations({
            token: Biscuit.get('token'),
            suffix: "",
            filter: {
                ...filter,
                status: 'completed'
            }
        }));

        props.dispatch(reservationsActions.getReservations({
            token: Biscuit.get('token'),
            suffix: "",
            filter: {
                ...filter,
                status: 'confirmed'
            }
        }));
*/
        //setInitialized(true);
    };

    initialize();

    return(
        <>
        <MicroWidget
            position={props.position}
            icon="inb-fi-checkin"
            title={t('checkin_reservation') + "\n" + t('today')}
            value={getCheckinsToday() + "/" + getPossibleCheckinsToday()}/>
        </>
    );
};

export default WidgetCheckins;


/*
let reservationFilter = "begin_lt=" + moment().format("YYYY-MM-DD HH:mm:ss");
    reservationFilter += "&end_gte=" + moment().format("YYYY-MM-DD HH:mm:ss");
    reservationFilter += "&finder=NotCancelled";

    Buchungen die heute starten

    heutige checkins bisher / mögliche checkins heute


    heutige checkins bisher:

    reservierungen mit checkin today


    mögliche checkins heute:

    reservierungen die vor tagesende beginnen UND die nach dem Tagesanbruch enden

    - die erst am nächsten tag beginnenden sind raus
    - die bereits vor tagesanbruch enden sind auch raus

    -> dann checkins und status prüfen:

       - bereits vor heute ausgecheckt? -> raus (bereits vor heute abgeschlossen)
       - bereits vor heute eingecheckt? -> raus
       - alle übrigen können heute eingecheckt werden:
           - bereits eingecheckt? -> links anzeigen


           2021-08-19%2023:59:59
*/